import React from "react";
import { useTranslation } from "react-i18next";

/** "Export format" popup (Excel / CSV). Open it with data-bs-toggle="modal" data-bs-target={`#${id}`}. */
export const ExportFormatModal = ({ id, format, setFormat, onExport, buttonLabel }) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  return (
    <div
      className="modal fade common-modal"
      id={id}
      tabIndex={-1}
      aria-labelledby={`${id}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <img
              className="common-modal-exclamation-img"
              src={base_assets + "images/icons/exclamation-mark-green.png"}
              alt=""
            />
            <p className="modal-content-text mb-2">{t("Export format")}</p>
            <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
              <label className="d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name={`${id}Format`}
                  value="xlsx"
                  checked={format === "xlsx"}
                  onChange={() => setFormat("xlsx")}
                />
                {t("Excel (.xlsx)")}
              </label>
              <label className="d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name={`${id}Format`}
                  value="csv"
                  checked={format === "csv"}
                  onChange={() => setFormat("csv")}
                />
                {t("CSV")}
              </label>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn modal-content-yes"
              data-bs-dismiss="modal"
              onClick={() => onExport()}
            >
              {t(buttonLabel || "Export")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportFormatModal;
